/** Adds `id` to the selection, or removes it if it's already there. */
export const toggleSelection = (selectedIds: string[], id: string) => (
  selectedIds.includes(id)
    ? selectedIds.filter((selectedId) => selectedId !== id)
    : [...selectedIds, id]
)

/** A click: toggles `id` when adding to the selection, otherwise selects it alone. */
export const clickSelection = (selectedIds: string[], id: string, additive: boolean) => (
  additive ? toggleSelection(selectedIds, id) : [id]
)

/** The rectangle between two corners, whichever way it was drawn. */
export const rectBetween = (a: { x: number; y: number }, b: { x: number; y: number }) => ({
  x: Math.min(a.x, b.x),
  y: Math.min(a.y, b.y),
  width: Math.abs(a.x - b.x),
  height: Math.abs(a.y - b.y),
})
